import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getListProgramStart,
  getListProgramSuccess,
  getListProgramFailed,
} from "../redux/getListProgram";
import { getListProgramApi } from "core/http/service/interviewSchedule";

function* getListProgramWork() {
  try {
    const res = yield call(getListProgramApi);
    yield put({
      type: getListProgramSuccess.type,
      payload: res,
    });
  } catch (error: any) {
    yield put({
      type: getListProgramFailed.type,
    });
  }
}

function* watchGetListProgram() {
  yield takeLatest(getListProgramStart.type, getListProgramWork);
}

export default function* getListProgramSaga() {
  yield all([watchGetListProgram()]);
}
